import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface AlertNotification {
  type: 'success' | 'error' | 'warning';
  message: string;
  fadeOut?: boolean; 
  show?: boolean;
}

@Injectable({
  providedIn: 'root'
})

export class AlertNotificationService {
  private notificationSubject = new Subject<AlertNotification>();
  public notifications$ = this.notificationSubject.asObservable();

  constructor() {}

  success(message: string) {
    this.notificationSubject.next({ type: 'success', message });
  }

  error(message: string) {
    this.notificationSubject.next({ type: 'error', message });
  }

  warning(message: string) {
    this.notificationSubject.next({ type: 'warning', message });
  }
}
